// extracted by mini-css-extract-plugin
export var modalBody = "WithdrawModal-module--modalBody--4868f";